<template>
  <div class="col-sm-12 col-md">
    <b-form-group :label="computedLabel">
      <!-- File input for new files -->
      <b-form-file
        id="input-government-issued-id"
        v-model="model"
        :state="errors ? false : null"
        :placeholder="computedPlaceholder"
        @change="inputChange"
        @input="onInput"
        :required="required"
        :browse-text="$t('Browse')"
        accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
        multiple
        :disabled="disabled"
      />
      <div v-if="errors" class="invalid-feedback d-block">
        {{ errors }}
      </div>
      <UploadedFilesList 
        :files="existingFiles" 
        :deleted-files="deletedFiles"
        @remove="onRemoveExistingFile"
        @mark-for-deletion="onMarkFileForDeletion"
        @restore="onRestoreFile"
      />
    </b-form-group>
  </div>
</template>

<script>
import BaseInputMixin from "../../../../mixins/profileInputMixin";
import {mapState} from "vuex";
import UploadedFilesList from "./UploadedFilesList.vue";
import identificationFilesMixin from "../../../../mixins/identificationFilesMixin";

export default {
  name: "GovernmentIssuedId",
  mixins: [BaseInputMixin('government_issued_id', 'identityVerification', 'identityVerificationFieldOnInput'), identificationFilesMixin('government_issued_id')],
  components: { UploadedFilesList },
  data() {
    return {
      defaultLabel: this.$t("Government Issued ID"),
      defaultPlaceholder: this.$t("Choose files...")
    }
  },
  computed: {
    ...mapState({})
  }
}
</script>

<style scoped>

</style>
